import { render, staticRenderFns } from "./Vesting.vue?vue&type=template&id=1f6fc06c&"
import script from "./Vesting.vue?vue&type=script&lang=js&"
export * from "./Vesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports